export const loadLocales = {
  'en-US': () => import('@/locales/en-US.json'),
  // 默认加载的语言
  // 'zh-CN': require('@/locales/zh-CN.json'),
  // 香港地区
  'zh-HK': () => import('@/locales/hk/zh-HK.json'),
  'en-HK': () => import('@/locales/hk/en-HK.json'),
  'zh-CN-HK': () => import('@/locales/hk/zh-CN-HK.json'), // 香港站点下的中文简体
  // 泰国
  'th-TH': () => import('@/locales/th-TH.json'),
  // 台湾地区
  'zh-TW': () => import('@/locales/tw/zh-TW.json'),
  'zh-CN-TW': () => import('@/locales/tw/zh-CN-TW.json'),
  'en-TW': () => import('@/locales/tw/en-TW.json'),
  // 越南
  'vi-VN': () => import('@/locales/vi-VN.json'),
  // 日本
  'ja-JP': () => import('@/locales/ja-JP.json'),
  // 韩国
  'ko-KR': () => import('@/locales/ko-KR.json'),
}

export async function getLocalesMessage(locale) {
  //  默认中文
  if (locale === 'zh-CN') {
    return require('@/locales/zh-CN.json')
  }
  if (loadLocales[locale]) {
    const messages = await loadLocales?.[locale]?.()
    if(messages?.default){
      return messages.default
    }
  }
}


// il8n设置语言包
export async function loadLanguageAsync(i18n, locale) {
  if (loadLocales[locale]) {
    const messages = await getLocalesMessage(locale)
    i18n.setLocaleMessage(locale, messages)
  }
}
